import React from 'react';
import useChangePasswordHooks from './changePassword-hooks';
import AuthInput from '../../../../Inputs/AuthInput/authInput';
import Button from '../../../../Button/button';
import { useGeneralHooks } from '../../../../../Hooks/hooks';
import { ButtonTypes } from '../../../../../Interfaces/componentTypes';
import { usePassword } from '../../../../Inputs/input-hooks';
import { HidePassword, SecureIcon, ShowPassword } from '../../../../../Assets/Icons';
import styles from './cahngePassword.module.scss';

interface IProps {
  onClose: () => void
}

const ChangePasswordDialog: React.FC<IProps> = ({ onClose }) => {
  const { register, onSubmit, handleSubmit, errors, onCloseDialog, isLoading } = useChangePasswordHooks(onClose);
  const { password, changeType } = usePassword();
  const {t} = useGeneralHooks();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <img src={SecureIcon} alt='SecureIcon' />
          <p>{t('Home.User_Drawer.Change_Password')}</p>
        </div>
      </div>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <AuthInput
          register={register}
          registerName='old_password'
          label={t('Input_Labels.Old_Password')}
          message='Incorrect E-mail Address'
          error={errors.old_password}
          type={password ? 'password' : 'text'}
          children={
            <img
              className={styles.inputIcon}
              src={password ? HidePassword : ShowPassword}
              alt="eyeIcon"
              onClick={changeType}
            />
          }
        />
        <AuthInput
          register={register}
          registerName='new_password'
          label={t('Input_Labels.New_Password')}
          message='Enter in the format Pass987#'
          error={errors.new_password}
          type={password ? 'password' : 'text'}
          patternValue={
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#/+_,.^])[A-Za-z\d@$#!%*.,^/+_?&]{8,}$/gm
          }
          children={
            <img
              className={styles.inputIcon}
              src={password ? HidePassword : ShowPassword}
              alt="eyeIcon"
              onClick={changeType}
            />
          }
        />
        <div className={styles.buttonsRow}>
          <Button
            type='button'
            buttonType={ButtonTypes.Secondary}
            title={t('Buttons.Close')}
            onClick={onCloseDialog}
            buttonStyle={styles.closeButton}
            buttonTitleStyle={styles.buttonTitle}
          />
          <Button
            type='submit'
            buttonType={ButtonTypes.Primery}
            title={t('Buttons.Save')}
            isLoading={isLoading}
            buttonStyle={styles.button}
            buttonTitleStyle={styles.buttonTitle}
          />
        </div>
      </form>
    </div>
  )
}

export default ChangePasswordDialog
